(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["columns-control"] && !Shopify.designMode) return;
  try {
    // Initialize columns control
  (function() {
    const savedColumns = sessionStorage.getItem('product-grid-columns');
    
    function applyColumns(value) {
      // Support multiple grid containers
      const grids = document.querySelectorAll('.collection-grouped-products, .store-grouped-products, .product-grid');
      grids.forEach(grid => {
        grid.style.setProperty('--products-per-row', value);
      });
    }
    
    if (savedColumns) {
      const input = document.querySelector(`.columns-control__input[value="${savedColumns}"]`);
      if (input) {
        input.checked = true;
      }
      applyColumns(savedColumns);
    }

    // Add event listeners
    document.querySelectorAll('.columns-control__input').forEach(input => {
      input.addEventListener('change', function() {
        const value = this.value;
        applyColumns(value);
        sessionStorage.setItem('product-grid-columns', value);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
